import { render, staticRenderFns } from "./SiteViolationReportForm.vue?vue&type=template&id=25d5829a&scoped=true&"
import script from "./SiteViolationReportForm.vue?vue&type=script&lang=js&"
export * from "./SiteViolationReportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d5829a",
  null
  
)

export default component.exports